import React from 'react';
interface Props {
  fillColor?: string;
}
function NonPbs({ fillColor = '#17385D' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none">
      <path
        d="M3.5 3.25C4.60313 3.25 5.5 4.14687 5.5 5.25V8.75H1.5V5.25C1.5 4.14687 2.39687 3.25 3.5 3.25ZM0 5.25V12.25C0 14.1844 1.56562 15.75 3.5 15.75C5.43437 15.75 7 14.1844 7 12.25V5.25C7 3.31562 5.43437 1.75 3.5 1.75C1.56562 1.75 0 3.31562 0 5.25ZM13 14.25C11.0656 14.25 9.5 12.6844 9.5 10.75C9.5 10.0562 9.70312 9.40625 10.0531 8.8625L14.8875 13.6969C14.3438 14.0469 13.6938 14.25 13 14.25ZM11.1125 7.80312C11.6562 7.45312 12.3062 7.25 13 7.25C14.9344 7.25 16.5 8.81563 16.5 10.75C16.5 11.4438 16.2969 12.0938 15.9469 12.6375L11.1125 7.80312ZM13 15.75C14.3261 15.75 15.5979 15.2232 16.5355 14.2855C17.4732 13.3479 18 12.0761 18 10.75C18 9.42392 17.4732 8.15215 16.5355 7.21447C15.5979 6.27678 14.3261 5.75 13 5.75C11.6739 5.75 10.4021 6.27678 9.46447 7.21447C8.52678 8.15215 8 9.42392 8 10.75C8 12.0761 8.52678 13.3479 9.46447 14.2855C10.4021 15.2232 11.6739 15.75 13 15.75Z"
        fill={fillColor}
      />
    </svg>
  );
}

export default NonPbs;
